// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/assets/fonts/hexagon-capital/Georgia.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@/assets/fonts/hexagon-capital/Georgia Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@/assets/fonts/hexagon-capital/Georgia Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@/assets/fonts/hexagon-capital/Georgia Bold Italic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* stylelint-disable no-empty-source */\n/* stylelint-disable no-invalid-position-at-import-rule */\n/* stylelint-disable no-duplicate-at-import-rules */\n/* stylelint-disable scss/dollar-variable-empty-line-before */\n@font-face {\n  font-family: Georgia;\n  src: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: Georgia;\n  src: url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ") format(\"truetype\");\n  font-weight: bold;\n  font-style: normal;\n}\n@font-face {\n  font-family: Georgia;\n  src: url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + ") format(\"truetype\");\n  font-weight: normal;\n  font-style: italic;\n}\n@font-face {\n  font-family: Georgia;\n  src: url(" + ___CSS_LOADER_URL_REPLACEMENT_3___ + ") format(\"truetype\");\n  font-weight: bold;\n  font-style: italic;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors-primary": "#1b5c8f",
	"colors-success": "#28c76f",
	"colors-danger": "#ea5455",
	"colors-warning": "#ffba00",
	"colors-dark": "#1e1e1e",
	"colors-grey-dark": "#56595c",
	"colors-grey": "#b8c2cc",
	"colors-grey-light": "#dae1e7",
	"colors-white": "#fff",
	"colors-black": "#22292f",
	"colors-invisible": "rgba(0, 0, 0, 0)",
	"colors-benchmark": "#6b6862",
	"colors-benchmark-dark": "#5f5f5f",
	"colors-live": "#c7650a",
	"colors-content": "#0e0e0c",
	"misc-border-radius-px": "5px",
	"typography-font-family-sans-serif": "\"Georgia\", sans-serif"
};
export default ___CSS_LOADER_EXPORT___;
